import React from "react";

export const PermisionHRNoveltiesTable = ({ noveltiesUserPermision }) => {
	return (
		<div>
			<table className="tabla-procesos">
				<tbody>
					{noveltiesUserPermision.length > 0 ? (
						noveltiesUserPermision[0].noveltiesViewPermision.map((el) => (
							<tr className="fila-tabla-cuenstas" key={el}>
								<td className="colTableDocuments1">{el}</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
